import { render } from "./SecondPressing.vue?vue&type=template&id=c9abd07c&scoped=true"
import script from "./SecondPressing.vue?vue&type=script&lang=js"
export * from "./SecondPressing.vue?vue&type=script&lang=js"

import "./SecondPressing.vue?vue&type=style&index=0&id=c9abd07c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9abd07c"]])

export default __exports__